import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

export const validServiceAccountEmail = (value) => typeof value === 'string' &&
   /^[^\s@#{}]+@[^\s@#{}]+\.[^\s@#{}]+$/.test(value.trim());

export default class SetupGuidance extends React.Component {
   state = { copyStatus: null };

   copyEmail = async () => {
      const { email } = this.props;
      if (!validServiceAccountEmail(email)) return;
      try {
         await navigator.clipboard.writeText(email.trim());
         this.setState({ copyStatus: 'Email copied.' });
      } catch (error) {
         this.setState({ copyStatus: 'Unable to copy automatically. Select and copy the email above.' });
      }
   };

   render() {
      const { email } = this.props;
      const valid = validServiceAccountEmail(email);
      return (
         <section className='data-destinations-setup' aria-label='Google Sheets setup'>
            <h3>Set up your Google Sheet</h3>
            <ol>
               <li>Create or open a spreadsheet in Google Sheets.</li>
               <li>Share it with the OpsPerfect Google service account shown below.</li>
               <li>Copy the Spreadsheet ID from its URL.</li>
               <li>Register it as a Target below.</li>
               <li>Select the Target and click Verify Access.</li>
            </ol>
            <Typography variant='subtitle2'>OpsPerfect Google service-account email</Typography>
            {valid ? <div className='data-destinations-email'>
               <code>{email.trim()}</code>
               <Button onClick={this.copyEmail} size='small' variant='outlined'>Copy email</Button>
            </div> : <Typography role='alert'>Google Sheets sharing setup is not configured correctly for this environment. Contact your OpsPerfect administrator or support team.</Typography>}
            {this.state.copyStatus && <Typography role='status'>{this.state.copyStatus}</Typography>}
            <Typography variant='body2'>In a URL like https://docs.google.com/spreadsheets/d/SPREADSHEET_ID/edit, the ID is between /d/ and /edit.</Typography>
            <Typography variant='body2'>Viewer access is enough for current read-only Verify Access check. Editor access will be required for future data delivery. Verification does not test write access.</Typography>
         </section>
      );
   }
}
